import React from 'react';
import Icon from '../../../components/AppIcon';
import { format } from 'date-fns';

const PointHistoryItem = ({ transaction }) => {
  const isEarned = transaction?.transactionType === 'earned' || transaction?.transactionType === 'bonus';
  const isRedeemed = transaction?.transactionType === 'redeemed';

  const getTransactionIcon = () => {
    if (isEarned) return 'TrendingUp';
    if (isRedeemed) return 'ShoppingCart';
    return 'AlertCircle';
  };

  const getTransactionColor = () => {
    if (isEarned) return 'var(--color-success)';
    if (isRedeemed) return 'var(--color-primary)';
    return 'var(--color-muted-foreground)';
  };

  const getCategoryLabel = (category) => {
    const labels = {
      account_setup: 'Account Setup',
      financial_habits: 'Financial Habits',
      engagement: 'Engagement',
      subscription: 'Subscription',
      referral: 'Referral'
    };
    return labels?.[category] || '';
  };

  return (
    <div className="flex items-center gap-16 p-16 hover:bg-muted/50 transition-smooth">
      <div 
        className="flex items-center justify-center w-10 h-10 rounded-lg flex-shrink-0"
        style={{ backgroundColor: `${getTransactionColor()}15` }}
      >
        <Icon 
          name={getTransactionIcon()} 
          size={20} 
          color={getTransactionColor()} 
          strokeWidth={2.5} 
        />
      </div>

      <div className="flex-1 min-w-0">
        <p className="text-sm font-medium text-card-foreground mb-2">
          {transaction?.description}
        </p>
        <div className="flex items-center gap-8">
          <span className="text-xs text-muted-foreground">
            {format(new Date(transaction?.createdAt), 'MMM d, yyyy h:mm a')}
          </span>
          {transaction?.category && (
            <>
              <span className="text-xs text-muted-foreground">•</span>
              <span className="text-xs text-muted-foreground">
                {getCategoryLabel(transaction?.category)}
              </span>
            </>
          )}
        </div>
      </div>

      <div className="flex items-center gap-6 flex-shrink-0">
        <span className={`text-lg font-heading font-bold ${
          isEarned ? 'text-success' : 'text-primary'
        }`}>
          {isEarned ? '+' : '-'}{Math.abs(transaction?.points)?.toLocaleString()}
        </span>
        <Icon name="Coins" size={16} color="var(--color-primary)" />
      </div>
    </div>
  );
};

export default PointHistoryItem;